import { FC } from 'react';
import classNames from 'classnames';

import { Membership, SubscriptionDetailsv4 } from '@bpm-web-app/supreme-api-sdk';
import styles from './your-plan.module.css';

type Props = {
    membership?: Membership
    status?: SubscriptionDetailsv4.StatusEnum
};

export const SubscriptionStatus: FC<Props> = ({ membership, status }) => {
    if (membership?.has_membership && !membership?.is_paused) {
        return (
            <span className={classNames(styles['plan__plan-status'], styles['plan__plan-status--active'])}>
                Active
            </span>
        );
    }

    if (membership?.has_membership && membership?.is_paused) {
        return (
            <span className={classNames(styles['plan__plan-status'], styles['plan__plan-status--paused'])}>Paused</span>
        );
    }

    if (status === SubscriptionDetailsv4.StatusEnum.Cancelled) {
        return (
            <span className={classNames(styles['plan__plan-status'], styles['plan__plan-status--inactive'])}>Inactive</span>
        );
    }

    return null;
};
